import { BaseResponse } from '@/_metronic/helpers/crud-helper/base-list-response'

export interface FilterReportRevenueSharing {
  set_sub_brand_id?: boolean
  sub_brand_id?: string[]
  set_brand_id?: boolean
  brand_id?: string[]
  set_area?: boolean
  area?: string[]
  set_region_id?: boolean
  region_id?: string[]
  set_city_id?: boolean
  city_id?: string[]
  set_outlet_id?: boolean
  outlet_id?: string[]
  set_month?: boolean
  month?: string[]
  set_year?: boolean
  year?: string | number | null
}

export interface ReportRevenueSharing {
  card?: Card
  card_share?: CardShare
  revenue_sharing?: CardShare[]
  revenue_sharing_wib?: CardShare[]
  revenue_sharing_wita?: CardShare[]
  revenue_sharing_wit?: CardShare[]
  revenue_top_outlet?: RevenueTopOutlet[]
  revenue_top_city?: RevenueTopCity[]
}

export interface Card {
  revenue?: number
  tax?: number
  service?: number
  revenue_after_tax_service?: number
  grandtotal?: number
}

export interface CardShare {
  revenue_share_outlet?: number
  revenue_share_partner?: number
  service_share_outlet?: number
  service_share_partner?: number
  periode?: string
  total_share_outlet?: number
  total_share_partner?: number
}

export interface RevenueTopCity {
  city_name?: string
  outlet_area?: string
  revenue_after_tax_service?: number
  revenue_share_outlet?: number
  revenue_share_partner?: number
  service_share_outlet?: number
  service_share_partner?: number
  total_share_outlet?: number
  total_share_partner?: number
}

export interface RevenueTopOutlet {
  outlet_guid?: string
  outlet_name?: string
  outlet_area?: string
  region_name?: string
  revenue_after_tax_service?: number
  revenue_share_outlet?: number
  revenue_share_partner?: number
  service_share_outlet?: number
  service_share_partner?: number
  total_share_outlet?: number
  total_share_partner?: number
}

export interface RevenueActualTarget {
  years?: number;
  month?: number;
  month_name?: string;
  target_outlet?: number;
  target_revenue_all?: number;
  target_revenue_alaya?: number;
  actual_outlet?: number;
  actual_revenue_all?: number;
  actual_revenue_alaya?: number;
  percentage_difference?: string;
}

export interface RevenueActualNewOutlet {
  year?: number;
  month?: number;
  month_name?: string;
  total_actual_outlet?: number;
  revenue_actual_outlet_all?: number;
  revenue_actual_outlet_alaya?: number;
  total_new_outlet?: number;
  revenue_new_outlet_all?: number;
  revenue_new_outlet_alaya?: number;
  total_revenue_all?: number;
  total_revenue_alaya?: number;
}

export interface ReportExistingVsProjectionVsNewOutlet {
  years?: number;
  total_outlet_existing?: number;
  revenue_outlet_existing?: number;
  total_outlet_projection?: number;
  revenue_target_projection?: number;
  total_outlet_new?: number;
  revenue_outlet_new?: number;
  grandtotal_revenue_outlet?: number;
  revenue_budgeting_target?: number;
  percentage?: string;
}

export interface ReportPnLvsTarget {
  years?: number;
  actual?: ReportPnLvsTargetActual;
  target?: ReportPnLvsTargetTarget;
  actual_against_target_percentage?: ReportPnLvsTargetActualAgainstTargetPercentage;
}

export interface ReportPnLvsTargetActual {
  revenue_all?: number;
  revenue_alaya?: number;
  costs?: number;
  cost_percentage?: string;
  profit?: number;
  profit_percentage?: string;
}

export interface ReportPnLvsTargetActualAgainstTargetPercentage {
  revenue_all?: string;
  revenue_alaya?: string;
  cost?: string;
  profit?: string;
}

export interface ReportPnLvsTargetTarget {
  revenue_all_target?: number;
  revenue_alaya_target?: number;
  revenue_all_difference?: number;
  revenue_alaya_difference?: number;
  profit_target?: number;
  cost_target?: number;
  cost_target_percentage?: string;
  profit_target_percentage?: string;
}

export interface ReportPnLLastYearVsTargetCurrentYear {
  actual_last_year?: ReportPnLActualLastYear;
  target_current_year?: ReportPnLActualLastYear;
  difference?: ReportPnLActualLastYear;
  percentage?: ReportPnLPercentage;
}

export interface ReportPnLActualLastYear {
  revenue_all?: number;
  revenue_alaya?: number;
  nop?: number;
  nett?: string;
}

export interface ReportPnLPercentage {
  revenue_all?: string;
  revenue_alaya?: string;
  nop?: string;
  nett?: string;
}

export interface ReportSummaryRevenueAll {
  name?: string;
  ytd?: number;
  budgeting?: number;
  last_year?: number;
  detail?: ReportSummaryRevenueDetail[];
}

export interface ReportSummaryRevenueDetail {
  month?: number;
  revenue?: number;
  cost?: number;
  nop?: number;
  roi?: string;
}

export type ReportRevenueSharingQueryResponse = BaseResponse<ReportRevenueSharing>
export type ReportRevenueActualTargetQueryResponse = BaseResponse<RevenueActualTarget>
export type ReportRevenueActualNewOutletQueryResponse = BaseResponse<RevenueActualNewOutlet>
export type ReportExistingVsProjectionVsNewOutletQueryResponse = BaseResponse<ReportExistingVsProjectionVsNewOutlet[]>
export type ReportPnLvsTargetTargetQueryResponse = BaseResponse<ReportPnLvsTarget>
export type ReportPnLLastYearVsTargetCurrentYearQueryResponse = BaseResponse<ReportPnLLastYearVsTargetCurrentYear>
export type ReportSummaryRevenueAllQueryResponse = BaseResponse<ReportSummaryRevenueAll[]>

const currentDate = new Date()
export const initialFilter: FilterReportRevenueSharing = {
  set_sub_brand_id: false,
  sub_brand_id: [],
  set_brand_id: false,
  brand_id: [],
  set_area: false,
  area: [],
  set_region_id: false,
  region_id: [],
  set_city_id: false,
  city_id: [],
  set_outlet_id: false,
  outlet_id: [],
  set_year: true,
  year: currentDate.getFullYear().toString(),
  set_month: false,
  month: [],
}
